import jQuery from 'jquery'


export const isRelated = (node,parent) => {
    while(node){
        if(node === parent) return true;
        node = node.parentNode;
    }
    return false;
}

export const createElement = html => {
    if(jQuery) return jQuery(html)[0];

    const outer = document.createElement('div');
    outer.innerHTML = html.trim();
    const element = outer.firstChild;
    outer.removeChild(element);
    return element;
}

/* import find,{matches,matchesSelector} from 'sizzle' */
const {find} = jQuery;
const {matches,matchesSelector} = find;

export {find,matches,matchesSelector};

export const elementList = (...args) => {
    let list = [];

    args.forEach(element => {
        if(typeof element === 'string') {
            element = find(element);
        }

        if (element instanceof HTMLElement || element instanceof SVGElement) {
            list = [...list,element];
        } else if (Array.isArray(element)) {
            list = [...list,...element];
        }
    })

    return list;
}

export const toggleClass = (element,className,force)=> {
    element = elementList(element);

    element.forEach(el => {
        if(jQuery){
            jQuery(el).toggleClass(className,force);
        }else{
            el.classList.toggle(className,force);
        }
    });
}

import classNames from 'classnames';
export const classes = (element,...classes) => {
    element = elementList(element);
    classes = classNames(classes);
    element.forEach(el => {
        el.className = classes;
    });
}

export const parents = (element,filter) => {
    return elementList(jQuery(element).parents(filter).toArray());
}

export const mediaQuery = (element,queryFunction) => {
    const [target] = elementList(element);
    const handleResize = ()=> {
        let width=0,height=0;
        if(target === window) {
            width = window.innerWidth;
            height = window.innerHeight;
        }else if(jQuery){
            width = jQuery(target).outerWidth(true);
            height = jQuery(target).outerHeight(true);
        }

        queryFunction({width,height});
    }

    window.addEventListener('resize',handleResize,false);
    handleResize();

    return {
        call:handleResize,
        off(){
            window.removeEventListener('resize',handleResize);
        }
    };
}

export const dispatchClick = (target) => {
    const evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0,
        false, false, false, false, 0, null);
    target.dispatchEvent(evt);
}

export const style = (element,style={}) => {
    element = elementList(element);
    element.forEach(el => {
        if(jQuery){
            jQuery(el).css(style);
        }else{
            Object.assign(el.style,style);
        }
    });
}

export const parseRGB = (str) => {
    const m = str.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
    if(m) return [m[1],m[2],m[3]].map(str=>parseFloat(str.trim()));
    else return [0,0,0];
}